import styled from 'styled-components';
import { color } from '../../templates/Ui';
export const Backdrop = styled.div `
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.75);
    z-index: 6;
    transition: opacity 0.2s ease-in-out;
    opacity: ${props => (props.open ? '1' : '0')};
    pointer-events: ${props => (props.open ? 'auto' : 'none')};
`;
export const Modal = styled.div `
    position: fixed;
    bottom: 15px;
    left: 50%;
    width: 100%;
    background-color: ${color.body.base};
    border-radius: 7px;
    transform: translateX(-50%);
    transition: opacity 0.2s ease-in-out;
    opacity: ${props => (props.open ? '1' : '0')};
    pointer-events: ${props => (props.open ? 'auto' : 'none')};
    overflow: hidden;
    z-index: 6;
    max-width: calc(100% - 30px);
    max-height: calc(100% - 40px);
    height: auto;

    @media only screen and (min-width: 768px) {
        max-width: ${props => (props.maxWidth ? props.maxWidth : '475px')};
        top: 50%;
        bottom: auto;
        transform: translate(-50%, -50%);
    }
`;
export const Header = styled.header `
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
`;
export const ContentContainer = styled.div `
    padding: 30px;
`;
export const Content = styled.div `
    overflow-y: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
`;
